import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { NgClass } from '@angular/common'

@Component({
  selector: 'pagination',
  imports: [MatIcon, NgClass],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent {
  @Input() currentPage: number = 1
  @Input() pageSize: number = 10
  @Input() totalRecords: number = 0
  @Output() pageChanged = new EventEmitter<number>()

  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--
      this.emitPageChange()
    }
  }

  goToNextPage(): void {
    const totalPages = Math.ceil(this.totalRecords / this.pageSize)
    if (this.currentPage < totalPages) {
      this.currentPage++
      this.emitPageChange()
    }
  }

  emitPageChange(): void {
    this.pageChanged.emit(this.currentPage)
  }
}
